/* eslint-disable i18next/no-literal-string */
import {Badge} from '@dropbox/dig-components/badge';
import {Text} from '@dropbox/dig-components/typography';
import {Stack} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronDownLine, ChevronRightLine} from '@dropbox/dig-icons/assets';
import cx from 'classnames';
import type {AskHealthLowAnswer} from 'client';
import {Link} from 'components/DSYS/Link';
import {MarkdownView} from 'components/DSYS/MarkdownView';
import {useState} from 'react';

import styles from './AskHealth.module.css';

/** One low-scored answer: click the question to see the answer and the judge's reason. */
export const AnswerRow = ({answer}: {answer: AskHealthLowAnswer}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.answerRow}>
      <div className={cx(styles.answerHead, {[styles.open]: open})}>
        <button
          type="button"
          className={styles.answerToggle}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <UIIcon src={open ? ChevronDownLine : ChevronRightLine} size="small" />
          <Text>“{answer.question}”</Text>
        </button>
        <div className={styles.answerMeta}>
          <Badge tone={answer.score > 0 ? 'warning' : 'alert'}>
            {answer.score > 0 ? 'Partly' : 'Wrong or empty'}
          </Badge>
          <Text size="small">
            <Link to={answer.trace_url}>Trace</Link>
          </Text>
        </div>
      </div>
      {open ? (
        <div className={styles.answerBody}>
          <Stack gap="12">
            {answer.judge_reason ? (
              <Stack gap="4">
                <Text tagName="div" size="small" isBold>
                  Why the judge scored it this way
                </Text>
                <Text tagName="div" size="small">
                  {answer.judge_reason}
                </Text>
              </Stack>
            ) : null}
            {answer.answer ? (
              <Stack gap="4">
                <Text tagName="div" size="small" isBold>
                  What Ask answered
                </Text>
                <div className={styles.answerText}>
                  <MarkdownView value={answer.answer} textSize="small" />
                </div>
              </Stack>
            ) : null}
            {!answer.judge_reason && !answer.answer ? (
              <Text tagName="div" size="small" color="subtle">
                Braintrust didn&apos;t return the details; open the trace to see them.
              </Text>
            ) : null}
          </Stack>
        </div>
      ) : null}
    </div>
  );
};
